document.addEventListener('DOMContentLoaded', function () {
    const parallaxElements = document.querySelectorAll('.section-parallax');
  
    function handleScroll() {
      if (window.innerWidth <= 768) return;
  
      parallaxElements.forEach((element) => {
        let containerHeight = element.clientHeight;
        let containerOffsetTop = element.getBoundingClientRect().top + window.scrollY;
        let windowHeight = window.innerHeight;
        let scrollPosition = window.scrollY;
        
        if (scrollPosition + windowHeight > containerOffsetTop && scrollPosition < containerOffsetTop + containerHeight) {
          let scrollTop = Math.max(0, scrollPosition - containerOffsetTop);
          let scrollPercentage = Math.min(scrollTop / (containerHeight + windowHeight), 1);
  
          let translateY = scrollPercentage * 16;
  
          requestAnimationFrame(() => {
            element.style.transform = `translateY(-${translateY}%)`;
          });
        } else {
          requestAnimationFrame(() => {
            element.style.transform = 'translateY(0)';
          });
        }
      });
    }
  
    function init() {
      if (window.innerWidth > 768) {
        window.addEventListener('scroll', handleScroll);
        handleScroll();  
      } else {
        parallaxElements.forEach((element) => element.style.transform = 'translateY(0)');
        window.removeEventListener('scroll', handleScroll);
      }
    }
  
    window.addEventListener('resize', init);
    init();
  });